module.exports = __webpack_public_path__ + "static/img/home_productcard_pu_mobile.9dd5e3f4.jpg";